<template>
  <a :href="app.link">
      <img :src="app.img" alt="">
      <h5>{{app.name}}</h5>
  </a>
</template>

<script>
export default {
  name: 'AppItem',
    props: {
        app: Object
    }
}
</script>

<style lang="scss" scoped>
a {
    display: flex;
    align-items: center;
    flex-direction: column;
}
img {
  width: 80%;
  // height: 8rem;
  margin-bottom: 0.8rem;
}
</style>